var _title, _desc, _defs, _g;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSubAccount = function SvgSubAccount(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\u692D\u5706\u5F62")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5DE5\\u4F5C\\u53F0/\\u89D2\\u8272\\u7BA1\\u7406/\\u5B50\\u8D26\\u53F7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E3B\\u8D26\\u53F7-\\u5DE5\\u4F5C\\u53F001",
    transform: "translate(-887.000000, -15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-70",
    transform: "translate(887.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u692D\\u5706\\u5F62"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fill: "#3B9F7B",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#49B38C",
    mask: "url(#mask-2)",
    cx: 7,
    cy: 3.5,
    rx: 17,
    ry: 11.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62\\u590D\\u5236-4",
    fill: "#4DC197",
    mask: "url(#mask-2)",
    cx: 5.5,
    cy: -1,
    rx: 13.5,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,9.4 C8.34314575,9.4 7,8.05685425 7,6.4 C7,4.74314575 8.34314575,3.4 10,3.4 C11.6568542,3.4 13,4.74314575 13,6.4 C13,8.05685425 11.6568542,9.4 10,9.4 Z M4.67320699,12.3055492 C6.44880466,10.7313217 8.22440233,9.94420797 10,9.94420797 C11.7756049,9.94420797 13.5512098,10.7313281 15.3268147,12.3055684 C15.754942,12.6851525 16,13.2299226 16,13.8020913 L16,14.4 C16,14.9522847 15.5522847,15.4 15,15.4 L5,15.4 C4.44771525,15.4 4,14.9522847 4,14.4 L4.0000179,13.8020613 C4.0000179,13.2298944 4.24507575,12.6851261 4.67320699,12.3055492 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSubAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/subAccount.65933c36.svg";
export { ForwardRef as ReactComponent };